import { observer } from 'mobx-react-lite'
import { type TermsModalViewModel } from './TermsModalViewModel'
import { TermsModal } from '@/features/iam/terms/TermsModal'

export interface TermsModalContainerProps {
  vm: TermsModalViewModel
}

export const TermsModalContainer = observer(function TermsModalContainer({
  vm,
}: TermsModalContainerProps) {
  return (
    <TermsModal
      showing={vm.modal.showing}
      termsContent={vm.termsContent}
      onAccept={vm.accept}
      isAcceptPending={vm.accept.pending}
    />
  )
})
